import { cn } from "@repo/ui/lib/utils";

export default function CoreValueItem({
  order,
  title,
  description,
  className,
}: {
  order: number | string;
  title: string;
  description: string;
  className?: string;
}) {
  return (
    <div className={cn("grid grid-cols-[56px_1fr] gap-4", className)}>
      <div className="flex flex-col items-start justify-center md:flex-row">
        <div className="font-bold leading-none text-7xl text-primary/70">
          {order}
        </div>
      </div>
      <div className="rounded-[20px] bg-grad-card">
        <div className="flex flex-col gap-4 px-5 py-3 md:flex-row font-helve">
          <h4 className="text-3xl font-semibold text-primary min-w-[150px]">
            {title}
          </h4>
          <p>{description}</p>
        </div>
      </div>
    </div>
  );
}
